
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeftOutlined } from '@ant-design/icons';
// import { FaWhatsapp } from 'react-icons/fa';
// import Llogo from '../img/Llogo.png';


// const formatDayMonth = (dateStr) => {
//   if (!dateStr) return 'N/A';
//   const date = new Date(dateStr);
//   if (isNaN(date)) return 'N/A';
//   return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;
// };

// const previewContainerStyle = {
//   width: '365px',
//   minHeight: '557px',
//   maxHeight: '667px',
//   margin: '10px auto',
//   border: '1px solid #ccc',
//   borderRadius: '20px',
//   overflow: 'hidden',
//   boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//   backgroundColor: '#f8f9fa',
//   display: 'flex',
//   flexDirection: 'column',
// };

// const listStyle = {
//   flex: 1,
//   overflowY: 'auto',
//   padding: '10px',
// };

// const memberCardStyle = {
//   display: 'flex',
//   padding: '10px',
//   backgroundColor: '#fff',
//   borderRadius: '10px',
//   marginBottom: '10px',
//   boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
//   flexDirection: 'column'
// };

// const MemberWeb = () => {
//   const navigate = useNavigate();
//   const [select, setSelect] = useState('Select Club');
//   const [isClicked, setIsClicked] = useState(false);
//   const [clubName, setClubName] = useState([]);
//   const [translatedData, setTranslatedData] = useState([]);
//   const [showMember, setShowMember] = useState(false);
//   const [searchText, setSearchText] = useState('');
//   const dist = sessionStorage.getItem('dist');

//   useEffect(() => {
//     fetchClubNames();
//   }, [dist]);

//   const fetchClubNames = async () => {
//     try {
//       const res = await axios.get('https://lionsdirectoryapi.emedha.in/club/api/clubName/get', {
//         params: { dist }
//       });
//       setClubName(res.data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const selectClubMember = async (name) => {
//     setSelect(name);
//     setIsClicked(false);
//     setShowMember(true);
//     try {
//       const resp = await axios.post('https://lionsdirectoryapi.emedha.in/search/member', { name, dist });
//       setTranslatedData(resp.data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const filterMembers = translatedData.filter((member) =>
//     member.membershipName &&
//     member.membershipName.toLowerCase().includes(searchText.toLowerCase())
//   );

//   return (
//     <div style={previewContainerStyle}>
//       {/* Header */}
//       <div style={{
//         backgroundColor: '#fff',
//         padding: '15px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between'
//       }}>
//         <div style={{ display: 'flex', alignItems: 'center' }}>
//           <ArrowLeftOutlined
//             style={{
//               fontSize: '18px',
//               color: '#0e3972',
//               cursor: 'pointer',
//               marginRight: '10px'
//             }}
//             onClick={() => navigate('/home')}
//           />
//           <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Members Info</h6>
//         </div>
//       </div>

//       {/* Dropdown + Search */}
//      {/* Club Dropdown */}{/* Club Dropdown */}
// <div style={{ padding: '10px' }}>
//   <button
//     onClick={() => {
//       setIsClicked(!isClicked);
//       setShowMember(false);
//       fetchClubNames();
//     }}
//     style={{ padding: '10px', width: '100%', marginBottom: '10px' }}
//   >
//     {select}
//   </button>

//   {/* Scrollable dropdown list only when isClicked */}
//   {isClicked && (
//     <div style={{ 
//       maxHeight: '300px', 
//       overflowY: 'auto', 
//       border: '1px solid #ccc', 
//       borderRadius: '6px',
//       backgroundColor: '#fff'
//     }}>
//       {clubName.map((club, idx) => (
//         <div
//           key={idx}
//           style={{
//             padding: '8px',
//             borderBottom: '1px solid #eee',
//             cursor: 'pointer'
//           }}
//           onClick={() => selectClubMember(club.clubName)}
//         >
//           {club.clubName}
//         </div>
//       ))}
//     </div>
//   )}
// </div>


// {/* Search Field */}
// {showMember && (
//   <div style={{ padding: '0 10px' }}>
//     <input
//       type="text"
//       placeholder="Search by Membership Name"
//       value={searchText}
//       onChange={(e) => setSearchText(e.target.value)}
//       style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
//     />
//   </div>
// )}


//       {/* Member List */}
//       <div style={listStyle}>
//         {showMember && filterMembers.map((member, idx) => (
//           <div key={idx} style={{...memberCardStyle, marginTop:'20px'}}>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//               <img
//                 src={member.photo || Llogo}
//                 alt=""
//                 style={{
//                   width: 60,
//                   height: 60,
//                   borderRadius: '100%',
//                   marginRight: '10px',
//                   border: '2px solid #ccc'
//                 }}
//               />
//               <div>
//                 <div>{member.membershipNo}</div>
//                 <div style={{ fontSize: '15px', fontWeight: 600 }}>{member.membershipName}</div>
           
//               </div>
//             </div>
//             <div style={{ marginTop: '10px', marginLeft: '70px' }}>
//               <div>BA: {formatDayMonth(member.birthAnniversary)}</div>
//               <div>MA: {formatDayMonth(member.marriageAnniversary)}</div>
//               <div style={{ fontSize: '14px' }}>{member.email}</div>
//               {member.mobile && (
//                 <div style={{ marginTop: '10px' }}>
//                   <a
//                     href={`https://wa.me/91${member.mobile}?text=hello`}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     style={{
//                       display: 'inline-block',
//                       backgroundColor: 'rgb(35, 155, 35)',
//                       color: 'white',
//                       padding: '5px 10px',
           
//                       textDecoration: 'none',
//                         borderRadius: '50%',
//                       fontSize: '14px'
//                     }}
//                   >
//                   <FaWhatsapp size={18} />
//                   </a>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MemberWeb;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronLeft, MessageCircle } from 'lucide-react';

const MembersList = ({ clubName, onBack, styles }) => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  const dist = sessionStorage.getItem("dist"); // district from session

  console.log("membersclubName",clubName)

  /* ---------------- FETCH MEMBERS ---------------- */
  const fetchMembers = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        "https://lionsdirectoryapi.emedha.in/search/member",
        { name: clubName, dist: dist } // include dist for filtering
      );
      setMembers(res.data);
    } catch (err) {
      console.error(err);
      alert("Error fetching members");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- LOAD ON MOUNT ---------------- */
  useEffect(() => {
    if (clubName) {
      fetchMembers();
    }
  }, [clubName]);

  return (
    <div style={styles.scrollArea}>
      {/* Header */}
      <div style={{ backgroundColor: '#0033A0', color: 'white', padding: '15px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
          <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} size={24} />
          <span style={{ fontSize: '18px', fontWeight: '500' }}>Back</span>
        </div>
        <h1 style={{ fontSize: '22px', margin: '5px 0 0 0' }}>{clubName}</h1>
        <p style={{ fontSize: '14px', margin: 0, opacity: 0.9 }}>
          {loading ? "Loading..." : `${members.length} Members`}
        </p>
      </div>

      {/* Members List */}
      <div style={{ padding: '15px' }}>
        {members.map((member) => {
          const initial = member.membershipName ? member.membershipName.charAt(0) : "?";
          return (
            <div key={member.memberId} style={{
              backgroundColor: 'white',
              borderRadius: '15px',
              padding: '20px',
              marginBottom: '15px',
              border: '1px solid #eee',
              position: 'relative',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{ display: 'flex', gap: '15px' }}>
           {/* Avatar */}
<div style={{
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  overflow: 'hidden', // so image fits circle
  backgroundColor: '#E9ECEF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#6C757D'
}}>
  {member.photo ? (
    <img 
      src={member.photo} 
      alt={member.membershipName} 
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  ) : (
    initial
  )}
</div>

                {/* Details */}
                <div style={{ flex: 1 }}>
                  <span style={{ fontSize: '12px', color: '#999' }}>Member ID: {member.memberId}</span>
                  <h3 style={{ margin: '2px 0 8px 0', fontSize: '18px', color: '#000' }}>{member.membershipName}</h3>
                  
                  <div style={{ fontSize: '14px', color: '#333', marginBottom: '4px' }}>
                    <span style={{ fontWeight: '500' }}>BA:</span> {member.birthAnniversary || "N/A"}
                  </div>
                  <div style={{ fontSize: '14px', color: '#333', marginBottom: '4px' }}>
                    <span style={{ fontWeight: '500' }}>MA:</span> {member.marriageAnniversary || "N/A"}
                  </div>
                  <div style={{ fontSize: '13px', color: '#666', marginTop: '8px' }}>
                    Email: <span style={{ color: '#0033A0' }}>{member.email || member.emailId || "N/A"}</span>
                  </div>
                </div>

                {/* WhatsApp Icon */}
              {/* WhatsApp Icon */}
<div
  onClick={() => {
    const number = member.mobile || member.mobile1;
    if (number) {
      // Open WhatsApp chat in new tab
      window.open(`https://wa.me/${number}`, "_blank");
    } else {
      alert("Mobile number not available");
    }
  }}
  style={{
    position: 'absolute',
    right: '15px',
    top: '20px',
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: '#EFFFF4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer', // show clickable
    color: '#25D366'
  }}
>
  <MessageCircle size={20} fill="#25D366" color="white" />
</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MembersList;